import React from 'react';

import './style/index.css';
import OptionsStore from '../../../Stores/OptionsStore';

function WeAreClosed() {
  return (
    <div className="we-are-closed">
      <div className="we-are-closed__inner">
        <div className="we-are-closed__title">Извините, мы закрыты</div>
        <div className="we-are-closed__ps">но обещаем, что скоро вернемся!</div>
        <div className="we-are-closed__ps"><hr/></div>
        <div className="we-are-closed__ps">Телефон службы поддержки:</div>
        <div className="we-are-closed__ps"><a href={`tel:${OptionsStore.contacts.phone}`}>{OptionsStore.contacts.phone}</a></div>
      </div>
    </div>
  );
}

export default WeAreClosed;
